import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Formik, FormikHelpers } from 'formik'
import { ObjectSchema } from 'yup'

import { Input } from 'common/components/dataEntry/formik'

import { Button, DatePicker, Modal } from 'common/components'
import { parseZone } from 'common/dateFormatters'

type CoverageProviderAddModalProps = {
  formValidator(translate: (key: string) => string): ObjectSchema<{ providerStartDate: Date; providerName: string }>
  date: string
  setShowModal: (boolean) => void
  showModal: boolean
  isCommandLoading: boolean
  onSubmit: (values: any, formikHelpers: FormikHelpers<any>) => void
}
const CoverageProviderAddModal: React.FC<CoverageProviderAddModalProps> = ({
  formValidator,
  date,
  setShowModal,
  showModal,
  isCommandLoading,
  onSubmit,
}: CoverageProviderAddModalProps) => {
  const { t: translate } = useTranslation(['ee-dashboard', 'translation'])
  const [isFormValid, setIsFormValid] = useState<boolean>(false)

  return (
    <>
      <Formik
        enableReinitialize={true}
        validationSchema={formValidator(translate)}
        initialValues={{
          providerName: '',
          providerStartDate: '',
        }}
        onSubmit={onSubmit}
        validate={(values) => {
          setIsFormValid(formValidator(translate).isValidSync(values))
        }}
      >
        {(formik) => {
          return (
            <form autoComplete="off">
              <Modal
                title={'Add Coverage Provider'}
                visible={showModal}
                destroyOnClose
                closable
                onCancel={() => {
                  setShowModal(false)
                }}
                footer={[
                  <Button
                    key="back"
                    onClick={() => {
                      setShowModal(false)
                    }}
                  >
                    {translate('translation:general.cancel')}
                  </Button>,
                  <Button
                    key="submit"
                    type="primary"
                    disabled={!isFormValid}
                    loading={isCommandLoading}
                    onClick={formik.submitForm}
                  >
                    {translate('translation:general.add')}
                  </Button>,
                ]}
              >
                <div className={'mb-16'}>
                  <Input
                    showRequiredSign={true}
                    label={'Provider Name'}
                    inputCustomStyle="mt-12"
                    name={`providerName`}
                    placeholder={'Provider name'}
                  />
                </div>

                <div className={'mb-16'}>
                  <DatePicker
                    showRequiredSign={true}
                    label={'Provider start date'}
                    labelBlock={true}
                    labelStyle="mb-12"
                    placeholder={'Select provider start date'}
                    name={`providerStartDate`}
                    id="ProviderStartDate"
                    disabledDate={(d) => !d || d.isAfter(parseZone(date).endOf('month'))}
                  />
                </div>
              </Modal>
            </form>
          )
        }}
      </Formik>
    </>
  )
}

export default CoverageProviderAddModal
